<template>
  <article class="printable-reward-link-redemption-instructions">
    <h2
      class="printable-reward-link-redemption-instructions__heading"
      v-html="
        $t('printable.landingPage.instructions.heading', {
          rewardName: rewardNameToDisplay
        })
      "
    />
    <p class="printable-reward-link-redemption-instructions__sub-heading">
      {{ $t('printable.landingPage.instructions.subheading') }}
    </p>
    <ul
      class="printable-reward-link-redemption-instructions__redemption-options"
    >
      <printable-reward-link-redemption-instruction
        v-for="instruction in instructions"
        :key="instruction"
        element-name="li"
        :message="instruction"
        :icon-color="iconColor"
      />
    </ul>
  </article>
</template>

<script>
import PrintableRewardLinkRedemptionInstruction from './PrintableRewardLinkRedemptionInstruction'
const DEFAULT_REWARD_NAME = 'Reward Link'

export default {
  name: 'PrintableRewardLinkRedemptionInstructions',
  components: { PrintableRewardLinkRedemptionInstruction },
  props: {
    rewardName: {
      type: String,
      required: false,
      default: DEFAULT_REWARD_NAME
    },
    iconColor: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    rewardNameToDisplay () {
      return this.rewardName || DEFAULT_REWARD_NAME
    },
    instructions () {
      return [
        this.$t('printable.landingPage.instructions.spendOption'),
        this.$t('printable.landingPage.instructions.doNotSpendOption')
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

$default-css-unicode-for-list-bullet: '\2022';

.printable-reward-link-redemption-instructions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.printable-reward-link-redemption-instructions__heading {
  font-size: 46px;
  font-weight: lighter;
}

.printable-reward-link-redemption-instructions__sub-heading {
  font-size: 20px;
  margin-bottom: 30px;
  max-width: 500px;
}

.printable-reward-link-redemption-instructions__heading,
.printable-reward-link-redemption-instructions__sub-heading {
  text-align: center;
}

.printable-reward-link-redemption-instructions__redemption-options {
  list-style: none;
  margin-bottom: 40px;
  padding: 0;

  > li {
    display: flex;
  }
}

.printable-reward-link-redemption-instructions__redemption-option-icon {
  font-size: 16px;
  margin-right: 10px;
}
</style>
